module.exports = __webpack_public_path__ + "img/document.4905cf72.svg";